import React, { useState, useEffect } from 'react'
import { Input } from 'antd'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap"
import apiBarcode from '../../../services/api/apiBarcode'

function BulkChangeNote(props) {
    const { selectedItems = [], items = [], resetBulkAll, reloadItems, closeMenu } = { ...props }
    const [isOpen, setIsOpen] = useState(false)
    const [itemsSuccess, setItemsSuccess] = useState([])
    const [itemsError, setItemsError] = useState([])
    const [listSelectedItem, setListSelectedItem] = useState([])
    const [note, setNote] = useState('')
    const [loadingBtn, setLoadingBtn] = useState(false)

    const { TextArea } = Input

    const handleShowModal = () => {
        setIsOpen(true)
    }

    const handleCloseModal = () => {
        setIsOpen(false)
        setItemsSuccess([])
        setItemsError([])
        setNote('')
        setLoadingBtn(false)
        closeMenu()
        resetBulkAll()
        reloadItems()
    }

    const handleChangeNote = (e) => {
        setNote(e.target.value)
    }

    const onSave = async () => {
        setLoadingBtn(true)
        try {
            const payload = {
                note: note,
            }
            let listSuccess = []
            let listError = []

            await Promise.all(listSelectedItem.map(async i => {
                try {
                    const resUpdated = await apiBarcode.updateBarcode(i._id, payload)
                    const { success, message } = resUpdated.data
                    if (success) {
                        listSuccess.push(i._id)
                    } else {
                        listError.push({ _id: i._id, message: message })
                    }
                } catch (error) {
                    listError.push({ _id: i._id, message: error.message })
                    console.log(error)
                }

            }))
            setItemsSuccess(listSuccess)
            setItemsError(listError)
            setLoadingBtn(false)

        } catch (error) {
            console.log(error)
        } finally {
            setLoadingBtn(false)
        }
    }

    const showMessage = (itemError, itemsSuccess, _id) => {
        if (itemError.find(itemErr => _id === itemErr._id) !== undefined) {
            if (itemError.find(itemErr => _id === itemErr._id).message) {
                return (
                    <span className="d-sm-block text-danger">{
                        itemError.find(itemErr => _id === itemErr._id).message
                    }</span>
                )
            } else {
                return (
                    <span className="d-sm-block">Loading...</span>
                )
            }
        } else if (itemsSuccess.includes(_id)) {
            return (
                <span className="d-sm-block text-success">Change Note success!</span>
            )
        } else {
            return (
                <span className="d-sm-block">Waiting...</span>
            )
        }
    }

    const renderIconLoading = () => {
        if (loadingBtn)
            return <i className='icon-spinner2 spinner ml-2' />
    }

    const getListItems = () => {
        const list = items.filter(i => selectedItems.includes(i._id))
        setListSelectedItem(list)
    }

    useEffect(() => {
        getListItems()
    }, [selectedItems])

    const listItemsDisable = listSelectedItem.filter(itemH => (['labelled', 'packaged', 'cancelled', 'cancel-ship'].includes(itemH.production_status)))
    const disabledBtn = listItemsDisable.length > 0

    return (
        <div className='BulkChangeNote'>
            <Button
                color="link"
                onClick={handleShowModal}
                className="mr-1 btn btn-link"
                disabled={disabledBtn}
            >
                Change Note
            </Button>
            {isOpen && (
                <Modal isOpen={isOpen} toggle={handleCloseModal} >
                    <ModalHeader toggle={handleCloseModal}>Ghi chú</ModalHeader>
                    <ModalBody>
                        <div className="ChangeNote">
                            {/* <h3>Ghi chú</h3> */}
                            {(!itemsSuccess.length && !itemsError.length) ?
                                <>
                                    <TextArea
                                        placeholder='Ghi chú'
                                        className='w-100 Note'
                                        value={note || ''}
                                        onChange={handleChangeNote}
                                        allowClear
                                        rows={6}
                                    />
                                </> : <>
                                    {
                                        listSelectedItem.length > 0 && (
                                            listSelectedItem.map(item => {
                                                return (
                                                    <div key={item._id} className="ItemChangeNote d-sm-flex mb-2 pb-2">
                                                        <div className="IconStatus mr-2">
                                                            {itemsSuccess.includes(item._id) && (
                                                                <i className="icon-check text-success" />
                                                            )}
                                                            {(itemsError.find(itemErr => item._id === itemErr._id) !== undefined &&
                                                                itemsError.find(itemErr => item._id === itemErr._id).message) && (
                                                                    <i className="icon-cross text-danger" />
                                                                )}
                                                        </div>
                                                        <div className="ContentItem">
                                                            <strong>#{item.barcodeNumber}</strong> - orderNumber: {item.orderNumber}
                                                            {showMessage(itemsError, itemsSuccess, item._id)}
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        )
                                    }
                                </>
                            }
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        {(!itemsSuccess.length && !itemsError.length) ?
                            <>
                                <Button color="secondary" onClick={handleCloseModal}>Cancel</Button>{' '}
                                <Button color="primary" onClick={onSave}>
                                    Save
                                    {loadingBtn ?
                                        renderIconLoading()
                                        : <i className="icon-quill4 ml-2" />
                                    }
                                </Button>
                            </> : <>
                                <Button disabled={false} onClick={handleCloseModal} className="bg-grey ml-2">
                                    Close
                                </Button>
                            </>}
                    </ModalFooter>
                </Modal>
            )}
        </div>
    )
}

export default BulkChangeNote